import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { AuthService, SharedService } from '@app/core';
import { ProfileService } from '@app/modules/profile/services';
import { PmdModal } from '@app/shared/propeller';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-detail-modal',
  templateUrl: './confirm-detail-modal.component.html',
  styleUrls: ['./confirm-detail-modal.component.scss']
})
export class ConfirmDetailModalComponent implements AfterViewInit {
  @ViewChild('confirmDetail', { static: true }) confirmDetail: PmdModal;
  @Input() currentStep = 2;

  constructor(private readonly sharedService: SharedService,
    public authService: AuthService, private readonly profileService: ProfileService,
    private readonly toaster: ToastrService,
  ) { }

  goToNextStep() {
    // this.currentStep += 1;

    const requestBody = {
      requestCallback: true
    }

    this.profileService.updateUserProfile(requestBody).subscribe({
      next: () => {
        this.toaster.success('Our team will reach to you shortly for next steps.', 'Call Back requested successfully.', {
          closeButton: true,
          disableTimeOut: true,
          messageClass: 'pl-28',
          toastClass: `pmd-toastr toast-success ngx-toastr`
        });
        this.confirmDetailHide();
      },
      error: (error) => {
        this.sharedService.errorAlert(error);
      }
    });
  }
  goToBackStep() {
    this.currentStep -= 1;
  }

  ngAfterViewInit(): void {
    this.openModalDetail();
  }

  openModalDetail() {
    this.confirmDetail.show();
  }

  confirmDetailHide() {
    this.confirmDetail.hide();
    this.sharedService.isPremiumUser.next(false);
  }

  getRemainingFreeTrialDays() {
    const rawDays = this.authService.user?.remainingFreeTrialDays ?? 0;
    const days = Number(rawDays); // force conversion to number
    return isNaN(days) ? 0 : days;
  }

}